import httpClient from 'shared/utils/http-client'
import {
  EventCreateInterface,
  EventEditInterface,
  EventId,
  EventViewInterface,
} from '../types/event-interface'

export const EVENTS_API = '/api/dashboard/booking-calendar/event'

export const removeEvent = (id: number) => httpClient.delete(`${EVENTS_API}?eventIds=${id}`)

export const updateEvent = (data: EventEditInterface) =>
  httpClient.put<EventViewInterface>(`${EVENTS_API}`, data)

export const createEvent = (data: EventCreateInterface) =>
  httpClient.post<EventViewInterface>(EVENTS_API, data)

export const getEventPreview = (eventId: EventId) =>
  httpClient.get(`/api/dashboard/editor/booking-calendar/event/${eventId}/preview`)
